<script setup lang="ts">
/*
 *
 * IMPORTS
 *
 * */

// PRIMEVUE
import { default as PRadioButton } from 'primevue/radiobutton'

// Custom components and types
import { QuizQuestionAnswerTrueFalse } from '@/core/domain/quiz/QuizQuestionAnswer.ts'
import { LearningQuizQuestionType } from '@/core/domain/resources/enums/LearningQuizQuestion.ts'

// VUE, VUE ROUTER, ETC...
import { type ModelRef, onMounted, ref, type Ref } from 'vue'

const answers: ModelRef<QuizQuestionAnswerTrueFalse[]> = defineModel('answers', {
  required: true
})

const props = defineProps<{
  canModifyStructure?: boolean
  canModifyContent?: boolean
}>()

const correctAnswer: Ref<boolean | null> = ref(null)

/**
 * Initialise la réponse à Vrai/Faux si elle n'existe pas déjà
 */
function initializeAnswer() {
  if (answers.value.length === 0) {
    answers.value = [
      QuizQuestionAnswerTrueFalse.create({
        label: 'Vrai',
        type: LearningQuizQuestionType.Values.TRUE_FALSE,
        isCorrect: true
      }),
      QuizQuestionAnswerTrueFalse.create({
        label: 'Faux',
        type: LearningQuizQuestionType.Values.TRUE_FALSE,
        isCorrect: false
      })
    ]
    correctAnswer.value = true
  } else {
    correctAnswer.value = answers.value[0].isCorrect
  }
}

/**
 * Met à jour la réponse correcte
 */
function updateAnswer() {
  if (correctAnswer.value !== null && answers.value.length > 0) {
    answers.value[0].isCorrect = correctAnswer.value
    answers.value[1].isCorrect = !correctAnswer.value
  }
}

// Initialiser la réponse au montage du composant
onMounted(() => {
  initializeAnswer()
})
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex items-center gap-2">
      <p-radio-button
        input-id="radio-true"
        v-model="correctAnswer"
        :value="true"
        name="true-false"
        :disabled="!props.canModifyContent"
        @update:model-value="updateAnswer"
      />
      <label for="radio-true" class="cursor-pointer">Vrai</label>
    </div>

    <div class="flex items-center gap-2">
      <p-radio-button
        input-id="radio-false"
        v-model="correctAnswer"
        :value="false"
        name="true-false"
        :disabled="!props.canModifyContent"
        @update:model-value="updateAnswer"
      />
      <label for="radio-false" class="cursor-pointer">Faux</label>
    </div>

    <!-- Messages d'information -->
    <div v-if="!props.canModifyContent" class="mt-2 text-xs text-red-600">
      <i class="pi pi-lock mr-1"></i>
      Version verrouillée - aucune modification autorisée
    </div>
  </div>
</template>
